import { render, staticRenderFns } from "./KategoriTanimlama.vue?vue&type=template&id=1a052d05&scoped=true&"
import script from "./KategoriTanimlama.vue?vue&type=script&lang=js&"
export * from "./KategoriTanimlama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a052d05",
  null
  
)

export default component.exports